import { TableColumnsType } from 'antd';
import { EntitiesByLei } from 'store/ducks/Reportings/types';

export const entitiesByLei: TableColumnsType<EntitiesByLei> = [
  {
    title: 'Name of entity',
    width: 150,
    dataIndex: 'name_of_entity',
    key: 'name_of_entity',
  },
  {
    title: 'Lei maintaining register',
    width: 150,
    dataIndex: 'lei_maintaining_register',
    key: 'lei_maintaining_register',
  },
  {
    title: 'Head office lei',
    width: 150,
    dataIndex: 'head_office_lei',
    key: 'head_office_lei',
  },
  {
    title: 'Financial reporting date',
    width: 150,
    dataIndex: 'financial_reporting_date',
    key: 'financial_reporting_date',
  },
  {
    title: 'Financial entity type name',
    width: 150,
    dataIndex: 'financial_entity_type_name',
    key: 'financial_entity_type_name',
  },
  {
    title: 'Financial entity name',
    width: 150,
    dataIndex: 'financial_entity_name',
    key: 'financial_entity_name',
  },
  {
    title: 'Financial entity country name',
    width: 150,
    dataIndex: 'financial_country_name',
    key: 'financial_country_name',
  },
  {
    title: 'Financial competent authority name',
    width: 150,
    dataIndex: 'financial_competent_authority_name',
    key: 'financial_competent_authority_name',
  },
  {
    title: 'Entity validity from',
    width: 150,
    dataIndex: 'entity_start_date',
    key: 'entity_start_date',
  },
  {
    title: 'Entity end date',
    width: 150,
    dataIndex: 'entity_end_date',
    key: 'entity_end_date',
  },
  {
    title: 'Branch validity from',
    width: 150,
    dataIndex: 'branch_start_date',
    key: 'branch_start_date',
  },
  {
    title: 'Branch name',
    width: 150,
    dataIndex: 'branch_name',
    key: 'branch_name',
  },
  {
    title: 'Branch identification code',
    width: 150,
    dataIndex: 'branch_identification_code',
    key: 'branch_identification_code',
  },
  {
    title: 'Branch end date',
    width: 150,
    dataIndex: 'branch_end_date',
    key: 'branch_end_date',
  },
  {
    title: 'Branch competent authority',
    width: 150,
    dataIndex: 'branch_competent_authority',
    key: 'branch_competent_authority',
  },
];
